var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "728.000000pt",
    height: "724.000000pt",
    viewBox: "0 0 728.000000 724.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,724.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6392 6787 c-210 -210 -382 -385 -382 -388 0 -7 396 -403 407 -406 4 -2 180 169 391 380 l382 382 -207 208 c-114 114 -207 207 -207 207 -1 0 -173 -172 -384 -383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5202 5597 l-382 -382 203 -203 c111 -111 207 -202 212 -202 6 0 181 171 390 380 l379 379 -20 23 c-43 51 -383 388 -391 388 -4 0 -180 -172 -391 -383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4020 4415 l-385 -385 208 -207 207 -208 387 387 388 388 -205 205 c-113 113 -207 205 -210 205 -3 0 -178 -173 -390 -385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2837 3232 c-207 -207 -377 -381 -377 -387 0 -5 91 -101 202 -212 l203 -203 382 382 c211 211 383 387 383 393 0 13 -392 405 -405 405 -6 0 -180 -170 -388 -378z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 2045 l-385 -385 208 -207 208 -207 387 387 387 387 -205 205 c-113 113 -207 205 -210 205 -3 0 -178 -173 -390 -385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 867 c-210 -210 -382 -385 -382 -389 0 -8 400 -408 409 -408 3 0 178 172 389 383 l382 382 -207 208 c-114 114 -207 207 -208 207 0 0 -172 -172 -383 -383z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashed);
export default __webpack_public_path__ + "static/media/dashed.0f8a31e5.svg";
export { ForwardRef as ReactComponent };